import styled from "styled-components";
import FadeInItem from "./FadeInItem";
import { BREAK_POINT } from "../constants";

const Description = () => {
  return (
    <Wrapper>
      <div>
        <FadeInItem>
          <div className="main">
            <div>
              <p>처음 본 순간,&nbsp;</p>
              <p>한눈에 반해버렸어!</p>
            </div>
            <div>
              <p>설레는 운명이 시작된&nbsp;</p>
              <p>우리의 첫 만남!</p>
            </div>
          </div>
        </FadeInItem>
        <FadeInItem>
          <div>
            <div>
              <p>인생의 소울메이트를&nbsp;</p>
              <p>꼭 만나길 바라는 ‘로미‘</p>
            </div>
            <div>
              <p>우연한 기회에&nbsp;</p>
              <p>‘하츄핑‘을 처음 본 뒤,&nbsp;</p>
              <p>운명의 인연임을 알아본다.</p>
            </div>
          </div>
        </FadeInItem>
        <FadeInItem>
          <div>
            <div>
              <p>‘로미‘는 ‘하츄핑‘을 찾기 위해&nbsp;</p>
              <p>반대를 무릅쓰고&nbsp;</p>
              <p>새로운 길을 떠나지만,</p>
            </div>
            <div>
              <p>마침내 만나게 된 ‘하츄핑‘은&nbsp;</p>
              <p>인간과의 소통을 거부하는데⋯</p>
            </div>
          </div>
        </FadeInItem>
      </div>
    </Wrapper>
  );
};

export default Description;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    word-break: keep-all;
    gap: 48px;
    border-top: 4px solid var(--lightSmoke);
    border-bottom: 4px solid var(--lightSmoke);
    padding: 94px 0;
    width: 80%;
    max-width: 960px;
  }

  p {
    font-size: 2.4rem;
    color: var(--darkPrimary);
    display: inline-block;
  }

  .main {
    p {
      font-size: 2.6rem;
      color: var(--primary);
      font-weight: 700;
    }
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    > div {
      padding: 42px 0;
    }

    p {
      font-size: 2rem;
    }

    .main {
      p {
        font-size: 2.2rem;
      }
    }
  }
`;
